/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  toast,
} from '@postscript/components';
import React from 'react';
import { Link } from 'react-router-dom';
import Events from '../../controllers/events';
import Requests from '../../controllers/network/network_requests';

class AppModal extends React.Component {
  constructor(props) {
    super(props);
    this.closeMe = this.closeMe.bind(this);
    this.completeMe = this.completeMe.bind(this);
  }

  completeMe() {
    if (this.props.modalObj)
      Events.track('Complete Modal Clicked', {
        header: this.props.modalObj.header,
      });
    if (this.props.modalObj && this.props.modalObj.announcement_id) {
      const path = '/shop/followed_announcement';
      const payload = {
        announcement_id: this.props.modalObj.announcement_id,
      };
      Events.track('Request Complete Announcement');
      Requests.post(path, payload).then((result) => {
        if (result && result.error) {
          Events.track('Complete Announcement Error');
          toast.error(result.error);
        } else if (result) {
          Events.track('Complete Accouncement Success');
        }
      });
    }
    this.closeMe();
  }

  // The CL Modal has no `onClosed` post-animation lifecycle, so the cleanup
  // that reactstrap ran via `onClosed` now fires directly on close.
  closeMe() {
    this.props.updateAppModal(null);
  }

  render() {
    return (
      <div>
        {this.props.modalObj ? (
          <Modal isOpen onCancel={this.closeMe}>
            <ModalHeader onCancel={this.closeMe}>
              {this.props.modalObj.header}
            </ModalHeader>
            <ModalBody className="display-linebreaks">
              <div>{this.props.modalObj.body}</div>
              <br />
              {this.props.modalObj.media_url ? (
                <div className="announcement-modal-image-container">
                  <img
                    src={this.props.modalObj.media_url}
                    alt="announcement-image"
                    className="announcement-modal-image"
                  />
                </div>
              ) : null}
            </ModalBody>
            <ModalFooter>
              {this.props.modalObj.path ? (
                <Link to={this.props.modalObj.path} onClick={this.completeMe}>
                  <Button variant="primary">
                    {this.props.modalObj.button}
                  </Button>
                </Link>
              ) : (
                <Button variant="primary" onClick={this.completeMe}>
                  {this.props.modalObj.button}
                </Button>
              )}
            </ModalFooter>
          </Modal>
        ) : null}
      </div>
    );
  }
}

AppModal.propTypes = {};

export default AppModal;
